import React from 'react';
import { Section } from './Section';
export function UniqueMechanism() {
  return <div className="py-24 relative overflow-hidden" data-id="element-256">
      <div className="absolute inset-0 bg-blood/5" data-id="element-257"></div>
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-blood/50 to-transparent" data-id="element-258"></div>
      <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-blood/50 to-transparent" data-id="element-259"></div>

      <Section className="max-w-4xl text-center relative z-10" data-id="element-260">
        <span className="text-blood font-sans text-xs font-bold tracking-widest uppercase mb-6 block" data-id="element-261">
          El Mecanismo Único
        </span>

        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-10 text-foreground" data-id="element-262">
          El Método de la Alquimia de la Sombra
        </h2>

        <div className="p-8 md:p-12 border border-blood/20 bg-background/80 backdrop-blur-sm relative" data-id="element-263">
          <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-blood" data-id="element-264"></div>
          <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-blood" data-id="element-265"></div>
          <div className="absolute bottom-0 left-0 w-4 h-4 border-b border-l border-blood" data-id="element-266"></div>
          <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-blood" data-id="element-267"></div>

          <p className="text-xl md:text-2xl font-serif leading-relaxed text-foreground/90" data-id="element-268">
            Este no es un libro de motivación. Es un tratado de ingeniería
            social inversa. En lugar de negar tus rasgos más "duros"
            (agresividad, ambición, escepticismo), aprenderás a integrarlos bajo
            el control de tu conciencia.
            <br data-id="element-269" />
            <br data-id="element-270" />
            Al reconocer tu propia sombra, te vuelves inmune a la sombra de los
            demás. Dejas de reaccionar emocionalmente y empiezas a operar
            estratégicamente utilizando la{' '}
            <strong className="text-blood font-normal" data-id="element-271">
              Neutralidad del Observador
            </strong>
            .
          </p>
        </div>
      </Section>
    </div>;
}